import { MouseEvent, useCallback } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import IconPlusLarge from '@picsart/icons/IconPlusLarge';

import { Button } from '../../../core/Button/Button';
import Typography from '../../../core/Typography';
import UploadArea from '../../../core/UploadArea';

import useStyles from './styles';
import IDragAndDropUpload from './types';

function DragAndDropUpload({
  className,
  accept,
  imgUrls,
  multiple = true,
  onUpload,
  onImageSelected,
  hideTitle,
}: IDragAndDropUpload) {
  const classes = useStyles();
  const { t } = useTranslation();

  const onSelect = useCallback(
    (url: string) => (e: MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onImageSelected(url);
    },
    [onImageSelected],
  );

  return (
    <div className={classes.root}>
      <UploadArea className={className} accept={accept} multiple={multiple} onUpload={onUpload}>
        {!hideTitle && (
          <Typography className={classes.description} element="p" color="var(--x-text-color-2)">
            {t('landing.heroBanner.dragArea.paragraph')}
          </Typography>
        )}
        <Button className={classes.cta}>
          <IconPlusLarge className={classes.addIcon} /> {t('landing.heroBanner.dragArea.cta')}
        </Button>
      </UploadArea>
      {imgUrls && (
        <div className={classes.examples}>
          <Typography element="strong" className={classes.imageTitle}>
            {t('landing.heroBanner.exampleArea.title')}
          </Typography>
          <div className={classes.images}>
            {imgUrls.map((imgUrl, index) => (
              <LazyLoadImage
                key={index}
                src={imgUrl}
                onClick={onSelect(imgUrl)}
                width={48}
                height={48}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DragAndDropUpload;
